import {Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CurriculaService, CommonService, EventsService, JobOffersService, ClevertapEventsService} from '../../services';
import * as moment from 'moment';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';

import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {BsModalService} from 'ngx-bootstrap';
import { environment } from 'environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ToasterService } from 'angular2-toaster';
import { LocalStorageHelpers } from 'app/helpers';
import { DigitalCareerDaysService } from 'app/services/digital-career-days.service';
import { Subject, TimeInterval } from 'rxjs';
import { JobOfferModel, UserJobsEntityModel } from 'app/interfaces';

@Component({
  selector: 'app-curriculum',
  templateUrl: './curriculum.component.html',
  styleUrls: ['./curriculum.component.scss'],
  providers: [EventsService]
})
export class CurriculumComponent implements OnInit, OnChanges {
  @ViewChild('iframe') iframe: HTMLIFrameElement;
  @Input() userId = null;
  @Input() curriculum: any = null;
  @Input() previousId = null;
  @Input() nextId = null;
  @Input() previousPage = null;
  @Input() nextPage = null;
  @Input() jobId: any;
  @Input() hideBackButton = false;

  @Input() careerDayId = null;
  @Input() careerDayExpired = false;

  @Output() previousClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() nextClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() previousPageClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() nextPageClick: EventEmitter<any> = new EventEmitter<any>();

  public job_id: any = false;
  public applier_id: number;
  public applier: {};
  public applications: UserJobsEntityModel[] = [];
  public checkIns = [];
  public statuses = {
    canSaveComment: false,
    savingComment: false,
    exportingCV: false
  };
  public exportLabel = '';
  modalRef: BsModalRef;
  template: TemplateRef<any>;
  public includeImage: boolean;

  public isLoading = false;

  // get iframeUrl(): SafeResourceUrl {
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(environment.curriculumUrl);
  // }

  get showPreviousButton(): boolean {
    console.log('showPreviousButton', this.previousId, this.previousPage);
    return this.previousId || this.previousPage !== null;
  }

  get showNextButton(): boolean {
    console.log('showNextButton', this.nextId, this.nextPage);
    return this.nextId || this.nextPage !== null;
  }

  clickOnPrevious() {
    if (this.previousId) {
      this.previousClick.emit(this.previousId);
    } else if (this.previousPage !== null) {
      this.previousPageClick.emit(this.previousPage);
    }
  }

  clickOnNext() {
    if (this.nextId) {
      this.nextClick.emit(this.nextId);
    } else if (this.nextPage !== null) {
      this.nextPageClick.emit(this.nextPage);
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
      console.log(event);
      if (event.key === 'ArrowRight') {
        this.clickOnNext();
      }
      if (event.key === 'ArrowLeft') {
        this.clickOnPrevious();
      }
      // if (event.key === 'x') {
      //   this.changeProcessStatus(this.applications.filter(a => this.job_id === a['JobOffer']['job_id'])[0], 'rejected');
      // }
      // if (event.key === 'v') {
      //   this.changeProcessStatus(this.applications.filter(a => this.job_id === a['JobOffer']['job_id'])[0], 'compliant');
      // }
      // if (event.key === '?') {
      //   this.changeProcessStatus(this.applications.filter(a => this.job_id === a['JobOffer']['job_id'])[0], 'not_sure');
      // }
  }

  public iframeUrl: SafeResourceUrl;

  private interval = null;
  private messageSent = new Subject<boolean>();
  private messageIsSent = this.messageSent.asObservable();

  constructor(
    private curriculaService: CurriculaService,
    private route: ActivatedRoute,
    private eventsService: EventsService,
    private commonService: CommonService,
    private modalService: BsModalService,
    private jobOfferService: JobOffersService,
    public sanitizer: DomSanitizer,
    private toasterService: ToasterService,
    private localStorageHelper: LocalStorageHelpers,
    private dcds: DigitalCareerDaysService
  ) {
    const obs = this.messageIsSent.subscribe((isSent) => {
      if (isSent && this.interval) {
        console.log('clear interval');
        clearInterval(this.interval);
        this.interval = null;
      }
    });
  }

  copyToClipboard($event: Event) {
    try {
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      // FIX-ME
      // check career day
      if (this.careerDayId !== null) {
        selBox.value = `${location.host}/career_days/${this.careerDayId}/job-offer/${this.jobId}/curricula/all?cvId=${this.userId}`;
      } else {
        selBox.value = `${location.host}/recruiting/curricula/${this.userId}`;
      }
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.toasterService.pop('success', 'Success', 'Candidate\'s Url copied to Clipboard!');
      // success toast
    } catch(e) {
      // error toast
      this.toasterService.pop('error', 'Error!', 'Please try again.')
    }
  }

  @HostListener('window:message', ['$event'])
  onMessage(event) {
    if (event && event.data && event.data.type && event.data.type === 'message-received') {
      this.messageSent.next(true);
      console.log('message received');
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ngOnInit();
  }

  isImgFromFb(img) {
    return this.commonService.isImgFromFb(img);
  }

  openVideo(video?) {
    const file = video;
    window.open(file, 'targetWindow',
      'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=400, height=600, left=200, top=100');
  }

  openConfirmModal(template: TemplateRef<any>) {
    this.template = template;
    this.includeImage = true;
    this.modalRef = this.modalService.show(template);
  }

  downloadCv(): void {
    const iframe = document.querySelector('iframe#ionicApp') as HTMLIFrameElement;

    iframe.contentWindow.postMessage({
      parent: 'employer-app',
      token: localStorage.getItem('token') || null,
      joi: this.applier_id,
      type: 'print-curriculum-from-employer'
    }, '*');
  }

  public setViewed(curriculum) {
    if (curriculum && !curriculum.viewed) {
      if (curriculum.application_id) {
        this.commonService.setApplicationViewed(curriculum.application_id).subscribe();
      } else if (curriculum.employers_id) {
        this.commonService.setEmployersUsersViewed(curriculum.User.id).subscribe();
        ClevertapEventsService.emitEvent('openedCv', {employers_id: curriculum.employers_id});
      }
    }
  }

  ngOnInit() {
    this.isLoading = true;
    this.route.params.subscribe(params => {
      if (!this.userId) {
        setTimeout(() => {
          window.scroll(0, 0);
        });
      } else {
        // FIX-ME focus on element
        try {
        const elmnt = document.getElementsByTagName('app-curriculum')[0];
        // elmnt.scrollIntoView();
        } catch (e) {}
      }
      const job_id = this.jobId || this.route.snapshot.queryParams['job_id'];
      if (job_id) {
        this.job_id = +job_id;
      }
      if (params['applier_id'] || this.userId) {
        this.applier_id = this.userId || +params['applier_id'];
        this.curriculaService.getCurriculum(this.applier_id, this.job_id)
          .subscribe(
            (applier: any) => {
              this.applier = {
                ...applier,
                User: {
                  img: applier.img,
                  name: applier.name,
                  surname: applier.surname,
                  status: applier.status,
                  birthdate: applier.birthdate,
                  email: applier.email,
                  contact_email: applier.contact_eamil,
                  phone: applier.phone,
                  contact_phone: applier.contact_phone,
                  contact_address: applier.contact_address
                },
                viewed: true
              }
              console.log(this.applier);
              this.setViewed(this.curriculum);
              this.isLoading = false;
            }, () => {
              this.isLoading = false;
            });
        this.refreshApplications();

        this.curriculaService.getCheckIns(this.applier_id)
          .subscribe(
            checkIns => {
              this.checkIns = checkIns;
              console.log('checkIns', checkIns);
            });

        // FIX-ME
        // emit event to iframe
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.curriculumUrl);

        if (!this.interval) {
          this.interval = setInterval(() => {
            const iframe = document.querySelector('iframe#ionicApp') as HTMLIFrameElement;
  
            if (iframe) {
              let win;
              // some browser (don't remember which one) throw exception when you try to access
              // contentWindow for the first time, it work when you do that second time
              try {
                  win = iframe.contentWindow;
              } catch(e) {
                  win = iframe.contentWindow;
              }
              const message = {
                parent: 'employer-app',
                token: localStorage.getItem('token') || null,
                joi: this.applier_id,
                type: 'employer-curriculum'
              };

              win.postMessage(message, '*');
  
              console.log('interval send message', this.interval)
            }
          }, 250);
        }

        // setTimeout(() => {
        //   const iframe = document.querySelector('iframe#ionicApp') as HTMLIFrameElement;

        //   if (iframe) {
        //     iframe.addEventListener('load', () => {
        //       setTimeout(() => {
        //         iframe.contentWindow.postMessage({
        //           parent: 'employer-app',
        //           token: localStorage.getItem('token') || null,
        //           joi: this.applier_id,
        //           type: 'employer-curriculum'
        //         }, '*');
        //       });
        //     }, false);
        //   }
        // }, 500);
      } else {
        this.isLoading = false;
      }
    })
  }

  formatBDay(date) {
    return moment().diff(date, 'years');
  }

  downloadEventCV(event_id?: number) {
    this.eventsService.downloadEventCV(event_id, this.applier_id)
      .subscribe(cvData => {
        let link;
        link = document.createElement('a');
        const formBlob = new Blob([cvData], {type: 'application/pdf'});
        link.href = window.URL.createObjectURL(formBlob);
        link.setAttribute('download', this.applier['name'].trim() + '_' +
          this.applier['surname'].trim() + '_CV_for_event_' + event_id + '.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }


  print(user) {

    console.log('Printing user cv', user);

    this.statuses.exportingCV = true;
    this.exportLabel = 'Generating PDF..';
    const that = this;
    const doc = new jsPDF({
      unit: 'pt'
    });

    if (user['img'] && this.includeImage) {

      const img = <HTMLImageElement>document.getElementsByClassName('applier_img')[0];
      img.crossOrigin = 'anonymous';
      if (user['img'].indexOf('s3.eu') > -1) {
        img.src += '?random';
      }

      html2canvas(img, {
        allowTaint: false,
        useCORS: true
      })
        .then(function (canvas) {
          const dataUrl = canvas.toDataURL('image/png');
          export_pdf({
            data: dataUrl,
            w: 100,
            h: 100
          });
        }).catch(err => {
        console.error(err);
      })
    } else {
      export_pdf();
    }

    this.modalRef.hide();


    function export_pdf(img?: object) {

      const config = {
        vertical_offset: 60,
        horizontal_offset: 60,
        format: 'JPG'
      };
      let w, h;

      if (img) {
        // console.log('img', img);
        if (img['data'].indexOf('image/png;')) {
          config.format = 'PNG'
        }
        doc.addImage(img['data'], config['format'], config['horizontal_offset'], config['vertical_offset'], img['w'], img['h'])
        w = img['w'];
        h = img['h'];
      } else {
        w = 0;
        h = 0;
      }

      // Header
      doc.setFontSize(16);
      doc.setFontType('bold');
      doc.text(img ? config['horizontal_offset'] + w + 10 : config['horizontal_offset'],
        config['vertical_offset'] + h / 5, user['name'] + ' ' + user['surname']);
      doc.setFontSize(12);
      doc.setFontType('normal');
      config['vertical_offset'] += +h / 5 + 10;
      addHeaderRow('Email', user['contact_email']);
      addHeaderRow('Phone', user['contact_phone']);
      addHeaderRow('City', user['city_name']);
      addHeaderRow('Birthdate', moment(user['birthdate']).format('DD MMMM YYYY'));
      ///////////////////


      if (img) {
        config['vertical_offset'] += h / 2
      }

      // University career
      addTitle('University career');
      for (let _i = user['academic_qualifications'].length - 1; _i >= 0; _i--) {
        addRow('Course', user['academic_qualifications'][_i]['course_name']);
        addRow('University', user['academic_qualifications'][_i]['university_name']);
        addRow('Qualification', user['academic_qualifications'][_i]['qualification_name']);
        addRow('Duration', moment(user['academic_qualifications'][_i]['started_at']).format('MMM YYYY') +
          ' - ' + moment(user['academic_qualifications'][_i]['finished_at']).format('MMM YYYY'));
        if (user['academic_qualifications'][_i]['vote']) {
          addRow('Vote', '' + user['academic_qualifications'][_i]['vote']);
        } else {
          addRow('Average', '' + user['academic_qualifications'][_i]['avg']);
        }
        config['vertical_offset'] += 10;
      }
      ///////////////////

      // Experiences
      addTitle('Experiences');
      for (let _i = user['experiences'].length - 1; _i >= 0; _i--) {
        const exp = user['experiences'][_i];
        addRow('Type', exp['ExperienceType']['name']);
        addRow('Title', exp['title']);
        addRow('Description', exp['description']);

        let duration = moment(exp['started_at']).format('MMM YYYY') + ' - ' + moment(exp['finished_at']).format('MMM YYYY');

        if (!exp['started_at'] && exp['finished_at']) {
          duration = moment(exp['finished_at']).format('MMM YYYY');
        }
        if (exp['started_at'] && !exp['finished_at']) {
          duration = moment(exp['started_at']).format('MMM YYYY') + ' - now';
        }
        if (!exp['started_at'] && !exp['finished_at']) {
          duration = ' - ';
        }


        addRow('Duration', duration);

        config['vertical_offset'] += 10;
      }
      ///////////////////

      // Skills
      addTitle('Skills');
      for (let i = user['skills'].length - 1; i >= 0; i--) {
        addRow(user['skills'][i]['Skill']['name'], user['skills'][i]['SkillLevel']['name']);
        config['vertical_offset'] += 10;
      }
      ///////////////////

      // Languages
      addTitle('Languages');
      for (let i = user['languages'].length - 1; i >= 0; i--) {
        addRow(user['languages'][i]['Language']['name'], user['languages'][i]['LanguageLevel']['name']);
        config['vertical_offset'] += 10;
      }
      ///////////////////


      // Save
      doc.save(user['name'] + '_' + user['surname'] + '_CV.pdf');
      that.statuses.exportingCV = false;
      ///////


      // Functions
      function addHeaderRow(title, content) {
        if (content) {
          config['vertical_offset'] += 15;
          doc.setTextColor(50);
          doc.setFontType('bold');
          doc.setFontSize(10);
          doc.text(img ? config['horizontal_offset'] + w + 10 : config['horizontal_offset'], config['vertical_offset'], title);
          doc.setTextColor(100);
          doc.setFontType('normal');
          doc.text(img ? config['horizontal_offset'] + w + 10 + 50 : config['horizontal_offset'] + 50, config['vertical_offset'], content);
        }
      }

      function addRow(title, content) {
        if (content) {
          content = decodeContent(content);
          const lines = doc.splitTextToSize(content, 340);
          config['vertical_offset'] += 15;
          checkPage();
          doc.setTextColor(10);
          doc.setFontSize(10);
          doc.setFontType('bold');
          doc.text(config['horizontal_offset'], config['vertical_offset'], title);
          doc.setTextColor(100);
          doc.setFontType('normal');
          doc.text(config['horizontal_offset'] + 150, config['vertical_offset'], lines);
          if (lines.length === 1) {
            config['vertical_offset'] += 0;
          } else {
            config['vertical_offset'] += 15 * (lines.length - 1);
          }
        }
      }

      function decodeContent(content) {
        return content.replace(/à/gi, 'à').replace(/â/gi, 'a').replace(/-/gi, ' ').replace(/"/gi, '').replace(/▪/gi, '-');
      }

      function addTitle(title) {
        checkPage();
        config['vertical_offset'] += 30;
        doc.setTextColor(0);
        doc.setFontType('bold');
        doc.setFontSize(12);
        doc.text(config['horizontal_offset'], config['vertical_offset'], title);
        config['vertical_offset'] += 5;
      }

      function checkPage(lines?: number) {
        if (config['vertical_offset'] > 770) {
          doc.addPage();
          config['vertical_offset'] = 80;
        }
      }

      //////////////////////////////
    }
  }

  async changeProcessStatus(curricula: Object, process_status: string) {
    console.log(curricula)
    if (curricula['process_status'] === process_status) {
      process_status = 'new';
    }
    const result = await this.jobOfferService.changeApplicationProcessStatus(curricula['applications_id'], process_status);
    curricula['process_status'] = result['process_status'];
    this.refreshApplications();
  }

  refreshApplications() {
    this.curriculaService.getApplications(this.applier_id)
      .subscribe(
        applications => {
          this.applications = applications.map((a: UserJobsEntityModel) => {
            a.id = a['applications_id'];
            a.JobOffer.id = a.JobOffer.job_id
            a.applied_at = a['created_at'];
            return a;
          });
          // console.log('applications', applications);
        });
  }

  // scheduleInterview
  scheduleInterview(application_id, user) {
    this.dcds.postScheduleInterview(this.careerDayId, application_id, {
      recruiters: [JSON.parse(this.localStorageHelper.get('userData')).id]
    }).subscribe(() => {
      this.toasterService.pop('success', 'Success', `The interview request with ${user.name} ${user.surname} has been successfully completed`);
      this.ngOnInit();
    }, (error) => {
      this.toasterService.pop('error', 'Error!', 'Please try again.')
      console.log(error);
    });
  }
}
